module.exports = __webpack_public_path__ + "media/MRI5C.46e37fa5.mp3";